import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Table from "../../react-components/table";
import Pagination from "../pagination";
import Heading from "../../elements/heading";
import { generateReactKey } from "../../utils/reactKey";

export default class TableContent extends Component {
  constructor(props, context) {
    super(props, context);
    const { fields } = this.props;
    const { tableData } = fields;
    let columnCount = 0,
      columnCountArr =
        tableData && tableData.fields ? tableData.fields.rows : [];
    columnCountArr.forEach((item, index) => {
      columnCount =
        item.fields.items.length > columnCount
          ? item.fields.items.length
          : columnCount;
    });
    this.state = {
      currentPage: 0,
      numberOfPages: Math.ceil(columnCount / 4),
      backgroundFadeStyle: null
    };
  }

  go(table, forward, columnCount) {
    let { currentPage } = this.state;
    this.setState(
      {
        currentPage:
          forward === true && currentPage < columnCount - 5
            ? currentPage + 1
            : forward === false && currentPage > 0
            ? currentPage - 1
            : currentPage
      },
      () => {
        if (
          (currentPage >= 0 && forward === false) ||
          (currentPage < columnCount - 1 && forward)
        ) {
          this.goToTablePage(table);
        }
      }
    );
  }

  goToTablePage(table) {
    let { currentPage, numberOfPages, backgroundFadeStyle } = this.state;
    const cssSnippet = `translateX(-${this.state.currentPage * 100}%)`;
    const headCells = table.refs.scrollContainer.querySelectorAll(
        "table thead th"
      ),
      bodyCells = table.refs.scrollContainer.querySelectorAll("table tbody td");
    let headCellsArr = [],
      bodyCellsArr = [];
    headCellsArr.forEach.call(headCells, function(element) {
      element.style.transform = element.className.match(/lead/)
        ? undefined
        : cssSnippet;
    });
    bodyCellsArr.forEach.call(bodyCells, function(element) {
      element.style.transform = element.className.match(/lead/)
        ? undefined
        : cssSnippet;
    });
    if (currentPage === numberOfPages - 1) {
      // remove fade.
      this.setState({
        backgroundFadeStyle: table.refs.scrollFilterContainer.style.background
      });
      table.refs.scrollFilterContainer.style.background = "none";
    } else {
      //add fade
      if (backgroundFadeStyle) {
        table.refs.scrollFilterContainer.style.background = backgroundFadeStyle;
      }
    }
  }

  tableContent(fields) {
    const { rendering, highlightRowDifferences } = this.props;
    const {
      alignment,
      gridType,
      paddingAboveTop,
      paddingAboveBottom,
      tableData,
      backgroundColor,
      headingBody,
      headingType,
      body
    } = fields;
    tableData.fields.highlightRowDifferences = highlightRowDifferences;
    let { currentPage, numberOfPages } = this.state;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom
        ? paddingAboveBottom.fields.phrase.value
        : "default",
      alignContent = alignment ? alignment.fields.phrase.value : "",
      gridTypeDate =
        gridType && gridType.fields.phrase.value === "story"
          ? "grid-story"
          : "grid";
    let columnCount = 0;
    const tableContentClasses = classNames(
        "table-content",
        "padding-top-" + top,
        "padding-bottom-" + bottom,
        alignContent,
        gridTypeDate
      ),
      titleClasses = classNames("title", "show-on-scroll"),
      paginationClasses = classNames("pagination-container"),
      columnCountArr =
        tableData && tableData.fields ? tableData.fields.rows : [],
      tableContentStyle = {};
    columnCountArr.forEach((item, index) => {
      columnCount =
        item.fields.items.length > columnCount
          ? item.fields.items.length
          : columnCount;
    });
    if (backgroundColor)
      tableContentStyle.background = backgroundColor
        ? backgroundColor.fields.phrase.value
        : "";

    return (
      <div
        key={generateReactKey()}
        className={tableContentClasses}
        datasourceid={rendering?.dataSource}
        style={tableContentStyle}
      >
        {headingBody && (
          <Heading
            className={titleClasses}
            {...{
              type: headingType,
              html: headingBody
            }}
          />
        )}
        {columnCount > 5 && (
          <div className={paginationClasses}>
            <Pagination
              pagination={{
                currentPage: currentPage,
                numberOfPages: numberOfPages
              }}
              onDotClicked={e => {
                this.setState({ currentPage: Number(e.target.id) }, () => {
                  this.goToTablePage(this.refs.table);
                });
              }}
              onClickedBack={e => this.go(this.refs.table, false, columnCount)}
              onClickedForward={e =>
                this.go(this.refs.table, true, columnCount)
              }
            />
          </div>
        )}

        {body.value && (
          <RichText tag="div" className={"body-text"} field={body} />
        )}
        <div className={"table-container"}>
          {tableData && <Table ref={"table"} {...tableData} />}
        </div>
      </div>
    );
  }

  headingDocumentChange(fields) {
    const { headingBody } = fields;
    if (headingBody.value) {
      let node = document.createElement("div");
      node.innerHTML = headingBody.value;

      if (node.firstChild && node.firstChild.className === "") {
        node.firstChild.className = "type-h1";
        headingBody.value = node.innerHTML;
      }
    }
  }

  componentDidMount(props) {
    const { fields } = this.props;
    this.headingDocumentChange(fields);
  }

  render() {
    if (!this.props.fields) return null;
    const { fields } = this.props;
    const { gridType } = fields;
    if (gridType && gridType.fields.phrase.value === "story") {
      return <div className={"grid"}>{this.tableContent(fields)}</div>;
    } else {
      return this.tableContent(fields);
    }
  }
}
